module.exports = __webpack_public_path__ + "static/media/nightcrawler.957a8228.jpg";